import { TextProps } from './'
import { systemDenseWeights } from './SystemDenseWeights'

const stylesInternal = {
  body10: {
    fontSize: 10,
    fontWeight: 'MEDIUM',
    lineHeight: 'TINY',
    color: 'TEXT_PRIMARY',
    fontFamily: 'poppins-medium',
  } as TextProps,
  body12: {
    fontSize: 'TINY',
    fontWeight: 'MEDIUM',
    lineHeight: 'TINY',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  bodyMedium12: {
    fontSize: 'TINY',
    fontWeight: 'bold',
    lineHeight: 'SMALL',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  body14: {
    fontSize: 'SMALL',
    fontWeight: 'MEDIUM',
    lineHeight: 'SMALL',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  bodyMedium14: {
    fontSize: 'SMALL',
    fontWeight: 'bold',
    lineHeight: 'SMALL',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  body16: {
    fontSize: 'MEDIUM',
    fontWeight: 'MEDIUM',
    lineHeight: 'MEDIUM',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  pending: {
    fontSize: 'MEDIUM',
    fontWeight: 'MEDIUM',
    lineHeight: 'MEDIUM',
    color: 'TEXT_PENDING',
  } as TextProps,
  error: {
    fontSize: 'MEDIUM',
    fontWeight: 'MEDIUM',
    lineHeight: 'MEDIUM',
    color: 'TEXT_ERROR',
  },
  body18: {
    fontSize: 'LARGE',
    fontWeight: 'MEDIUM',
    lineHeight: 'LARGE',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  bodySecondary14: {
    fontSize: 'SMALL',
    fontWeight: 'MEDIUM',
    lineHeight: 'SMALL',
    color: 'TEXT_SECONDARY',
  } as TextProps,
  bodySecondary16: {
    fontSize: 'MEDIUM',
    fontWeight: 'MEDIUM',
    lineHeight: 'MEDIUM',
    color: 'TEXT_SECONDARY',
  } as TextProps,
  bodySecondary18: {
    fontSize: 'LARGE',
    fontWeight: 'MEDIUM',
    lineHeight: 'LARGE',
    color: 'TEXT_SECONDARY',
  } as TextProps,
  label: {
    fontSize: 'TINY',
    fontWeight: 'MEDIUM',
    lineHeight: 'TINY',
    color: 'TEXT_SECONDARY',
  } as TextProps,
  titleBold16: {
    fontSize: 'MEDIUM',
    fontWeight: 'BOLD',
    lineHeight: 'MEDIUM',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleBold18: {
    fontSize: 'LARGE',
    fontWeight: 'BOLD',
    lineHeight: 'LARGE',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleBlack20: {
    fontSize: 'BIG',
    fontWeight: 'BLACK',
    lineHeight: 'BIG',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleBold20: {
    fontSize: 'BIG',
    fontWeight: 'BOLD',
    lineHeight: 'BIG',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleMedium20: {
    fontSize: 'BIG',
    fontWeight: 'MEDIUM',
    lineHeight: 'BIG',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleBlack26: {
    fontSize: 'BIGGER',
    fontWeight: 'BLACK',
    lineHeight: 'BIGGER',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleBold26: {
    fontSize: 'BIGGER',
    fontWeight: 'BOLD',
    lineHeight: 'BIGGER',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleMedium26: {
    fontSize: 'BIGGER',
    fontWeight: 'MEDIUM',
    lineHeight: 'BIGGER',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleBlack46: {
    fontSize: 'HUGE',
    fontWeight: 'BLACK',
    lineHeight: 'HUGE',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleMedium46: {
    fontSize: 'HUGE',
    fontWeight: 'MEDIUM',
    lineHeight: 'HUGE',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  titleLight46: {
    fontSize: 'HUGE',
    fontWeight: 'LIGHT',
    lineHeight: 'HUGE',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  subtitle14: {
    fontSize: 'SMALL',
    fontWeight: 'BOLD',
    lineHeight: 'SMALL',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  subtitle16: {
    fontSize: 'MEDIUM',
    fontWeight: 'BOLD',
    lineHeight: 'MEDIUM',
    color: 'TEXT_PRIMARY',
  } as TextProps,
  link12: {
    fontSize: 'TINY',
    fontWeight: 'MEDIUM',
    lineHeight: 'TINY',
    color: 'TEXT_LINK',
  } as TextProps,
  link14: {
    fontSize: 'SMALL',
    fontWeight: 'MEDIUM',
    lineHeight: 'SMALL',
    color: 'TEXT_LINK',
  } as TextProps,
  tertiaryAction12: {
    fontSize: 'TINY',
    fontWeight: 'MEDIUM',
    lineHeight: 'TINY',
    color: 'TEXT_LINK',
  } as TextProps,
  tertiaryAction14: {
    fontSize: 'SMALL',
    fontWeight: 'MEDIUM',
    lineHeight: 'SMALL',
    color: 'TEXT_LINK',
  } as TextProps,
}

type TextTypesOptions = keyof typeof stylesInternal
export type WeightTypesOption = 'normal' | 'dense'

type stylesType = {
  [key in TextTypesOptions]: { [weightKey in WeightTypesOption]: any }
}

const styles: stylesType = {
  body12: {
    normal: {
      ...stylesInternal.body12,
    } as TextProps,
    dense: {
      ...stylesInternal.body12,
      ...systemDenseWeights.bold,
    },
  },
  bodyMedium12: {
    normal: {
      ...stylesInternal.bodyMedium12,
    },
    dense: {
      ...stylesInternal.bodyMedium12,
      ...systemDenseWeights.bold,
    },
  },
  bodyMedium14: {
    normal: {
      ...stylesInternal.bodyMedium14,
    },
    dense: {
      ...stylesInternal.bodyMedium14,
      ...systemDenseWeights.bold,
    },
  },
  body14: {
    normal: {
      ...stylesInternal.body14,
    },
    dense: {
      ...stylesInternal.body14,
      ...systemDenseWeights.bold,
    },
  },
  body16: {
    normal: {
      ...stylesInternal.body16,
    },
    dense: {
      ...stylesInternal.body16,
      ...systemDenseWeights.bold,
    },
  },
  pending: {
    normal: {
      ...stylesInternal.pending,
    },
    dense: {
      ...stylesInternal.pending,
      ...systemDenseWeights.bold,
    },
  },
  error: {
    normal: {
      ...stylesInternal.error,
    },
    dense: {
      ...stylesInternal.error,
      ...systemDenseWeights.bold,
    },
  },
  body18: {
    normal: {
      ...stylesInternal.body18,
    },
    dense: {
      ...stylesInternal.body18,
      ...systemDenseWeights.bold,
    },
  },
  bodySecondary14: {
    normal: {
      ...stylesInternal.bodySecondary14,
    },
    dense: {
      ...stylesInternal.bodySecondary14,
      ...systemDenseWeights.bold,
    },
  },
  bodySecondary16: {
    normal: {
      ...stylesInternal.bodySecondary16,
    },
    dense: {
      ...stylesInternal.bodySecondary16,
      ...systemDenseWeights.bold,
    },
  },
  bodySecondary18: {
    normal: {
      ...stylesInternal.bodySecondary18,
    },
    dense: {
      ...stylesInternal.bodySecondary18,
      ...systemDenseWeights.bold,
    },
  },
  label: {
    normal: {
      ...stylesInternal.label,
    },
    dense: {
      ...stylesInternal.label,
      ...systemDenseWeights.bold,
    },
  },
  titleBold16: {
    normal: {
      ...stylesInternal.titleBold16,
    },
    dense: {
      ...stylesInternal.titleBold16,
      ...systemDenseWeights.bold,
    },
  },
  titleBold18: {
    normal: {
      ...stylesInternal.titleBold18,
    },
    dense: {
      ...stylesInternal.titleBold18,
      ...systemDenseWeights.bold,
    },
  },
  titleBlack20: {
    normal: {
      ...stylesInternal.titleBlack20,
    },
    dense: {
      ...stylesInternal.titleBlack20,
      ...systemDenseWeights.bold,
    },
  },
  titleBold20: {
    normal: {
      ...stylesInternal.titleBold20,
    },
    dense: {
      ...stylesInternal.titleBold20,
      ...systemDenseWeights.bold,
    },
  },
  titleMedium20: {
    normal: {
      ...stylesInternal.titleMedium20,
    },
    dense: {
      ...stylesInternal.titleMedium20,
      ...systemDenseWeights.bold,
    },
  },
  titleBlack26: {
    normal: {
      ...stylesInternal.titleBlack26,
    },
    dense: {
      ...stylesInternal.titleBlack26,
      ...systemDenseWeights.bold,
    },
  },
  titleBold26: {
    normal: {
      ...stylesInternal.titleBold26,
    },
    dense: {
      ...stylesInternal.titleBold26,
      ...systemDenseWeights.bold,
    },
  },
  titleMedium26: {
    normal: {
      ...stylesInternal.titleMedium26,
    },
    dense: {
      ...stylesInternal.titleMedium26,
      ...systemDenseWeights.bold,
    },
  },
  titleBlack46: {
    normal: {
      ...stylesInternal.titleBlack46,
    },
    dense: {
      ...stylesInternal.titleBlack46,
      ...systemDenseWeights.bold,
    },
  },
  titleMedium46: {
    normal: {
      ...stylesInternal.titleMedium46,
    },
    dense: {
      ...stylesInternal.titleMedium46,
      ...systemDenseWeights.bold,
    },
  },
  titleLight46: {
    normal: {
      ...stylesInternal.titleLight46,
    },
    dense: {
      ...stylesInternal.titleLight46,
      ...systemDenseWeights.bold,
    },
  },
  subtitle14: {
    normal: {
      ...stylesInternal.subtitle14,
    },
    dense: {
      ...stylesInternal.subtitle14,
      ...systemDenseWeights.bold,
    },
  },
  subtitle16: {
    normal: {
      ...stylesInternal.subtitle16,
    },
    dense: {
      ...stylesInternal.subtitle16,
      ...systemDenseWeights.bold,
    },
  },
  link12: {
    normal: {
      ...stylesInternal.link12,
    },
    dense: {
      ...stylesInternal.link12,
      ...systemDenseWeights.bold,
    },
  },
  link14: {
    normal: {
      ...stylesInternal.link14,
    },
    dense: {
      ...stylesInternal.link14,
      ...systemDenseWeights.bold,
    },
  },
  tertiaryAction12: {
    normal: {
      ...stylesInternal.tertiaryAction12,
    },
    dense: {
      ...stylesInternal.tertiaryAction12,
      ...systemDenseWeights.bold,
    },
  },
  tertiaryAction14: {
    normal: {
      ...stylesInternal.tertiaryAction14,
    },
    dense: {
      ...stylesInternal.tertiaryAction14,
      ...systemDenseWeights.bold,
    },
  },
  body10: {
    normal: {
      ...stylesInternal.body10,
    } as TextProps,
    dense: {
      ...stylesInternal.body10,
      ...systemDenseWeights.bold,
    },
  },
}

export default styles
